import notify from '@/utils/notify'
import errorMessages from '@/api/errors-handler/errorMessages'

export default function showHTTPErrorNotification(
  { status = '', message = '', custom = false } = {}
) {
  const errorExplanation = message || errorMessages[status] || ''
  return notify({
    title: `${ custom ? '' : 'HTTP Error' } ${ status }`,
    content: errorExplanation,
    type: 'negative'
  })
}
